




















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class OzLoadingText extends Vue {
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'
  @Prop() text!: string
}
